<template>
  <div ref="navbar" class="navbar">
    <div class="container">
      <h1 class="title">Sustainability Report 2022</h1>
      <Button
        class="burger-button"
        theme="white"
        size="small"
        @click="toggleMenu"
      >
        Menu
        <i class="icon icon-burger" />
      </Button>
    </div>
  </div>
  <div class="navigation" :class="{ 'navigation--open': isMenuOpen }">
    <div class="top">
      <div class="container">
        <h1 class="title">Sustainability Report 2022</h1>
        <Button
          class="burger-button"
          theme="white"
          size="small"
          @click="toggleMenu"
        >
          Close
          <i class="icon icon-cross" />
        </Button>
      </div>
    </div>

    <SustainabilityJumpToNav class="nav-items" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Button from "@/components/Button.vue";
import SustainabilityJumpToNav from "@/components/sustainability/SustainabilityJumpToNav.vue";

export default {
  name: "SustainabilityNavBar",
  components: {
    Button,
    SustainabilityJumpToNav,
  },
  computed: {
    ...mapState("sustainability", ["isMenuOpen"]),
  },
  mounted() {
    const observer = new IntersectionObserver(
      ([e]) => e.target.toggleAttribute("stuck", e.intersectionRatio < 1),
      { threshold: [1] }
    );

    observer.observe(this.$refs["navbar"]);
  },
  methods: {
    ...mapActions("sustainability", ["toggleMenu"]),
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  position: sticky;
  z-index: 9;
  top: -1px;
  background-color: transparent;
  margin-top: 20px;
  padding: 10px 0;
  height: 60px;
  margin-bottom: -80px;
  transition: background-color 0.2s;

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title {
    color: white;
  }

  &[stuck] {
    background-color: $color-white;

    .title {
      color: $color-dark;
    }
  }
}

.title {
  color: $color-dark;
  font-family: $body-font-family;
  text-transform: uppercase;
  font-size: 13px;
  transition: color 0.2s;
}

.burger-button {
  font-size: 10px;
  display: flex;
  align-items: center;

  .icon {
    font-size: 19px;
    margin-left: 13px;
  }
}

.navigation {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: white;
  z-index: 10;

  &--open {
    display: block;
  }

  .top {
    padding: 10px 0;
    & > .container {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .nav-items {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 120px 0;
  }
}

::v-deep() {
  .jump-to-nav button {
    @include respond-above(md) {
      margin: 1.5cqh 0;
      font-size: 6cqh;
    }
  }
}
</style>
